//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drafting.js";
import "../no/Object.js";
import "../no/Part.js";
let d=[[],[[[],"CreateCutCopyPasteBuilder",{R_:{builder:"Drafting.CutCopyPasteBuilder"}},0,0],[[],"CreateMoveToDrawingViewBuilder",{R_:{builder:"Drafting.MoveToDrawingViewBuilder"}},0,0],[[],"CreateSmashDrawingViewBuilder",{R_:{builder:"Drafting.SmashDrawingViewBuilder"}},0,0],[[],"DrawingsFreezeOutOfDateComputation",{},0,0],[[],"DrawingsUnfreezeOutOfDateComputation",{},0,0]],[["TitleBlocks","Annotations.TitleBlockCollection",0]]];
SPLM.Drafting.DraftingApplicationManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drafting.DraftingApplicationManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;